import React from "react";
import Skills from "./Skills/Skills";

const About = () => {
  return (
    <section className="py-0" data-scroll-reveal>
      <div className="flex flex-wrap w-full">
        <div className="w-full">
          {/* Unified Premium glass card container - About + Skills */}
          <div className="relative rounded-2xl overflow-hidden group">
            {/* Glass background */}
            <div className="absolute inset-0 bg-white/70 backdrop-blur-md" />
            
            {/* Gradient border */}
            <div className="absolute inset-0 rounded-2xl p-[2px] bg-gradient-to-br from-green-400/30 to-blue-400/20" />
            
            {/* Content */}
            <div className="relative z-10 p-6 md:p-8 rounded-2xl border border-white/40">
              {/* About Section */}
              <div className="mb-8">
                <h3 className="text-2xl md:text-3xl bg-gradient-to-r from-gray-900 via-green-600 to-gray-900 bg-clip-text text-transparent font-bold mb-4">
                  Who am I?
                </h3>
                <p className="text-sm md:text-base text-gray-700 leading-7 mb-4 font-light">
                  I'm Ikram, a 42 School student passionate about coding and problem solving. Through the program, I've developed strong fundamentals in C, C++, JavaScript, and modern development practices. I love building projects, debugging complex problems, and collaborating with peers in peer-led learning environments.
                </p>
                <p className="text-sm md:text-base text-gray-700 leading-7 font-light">
                  My experience spans full stack development, algorithms, and data structures. I'm self-motivated, always learning new technologies, and committed to writing clean, efficient code that solves real problems.
                </p>
              </div>

              {/* Divider */}
              <div className="h-px bg-gradient-to-r from-transparent via-green-400/30 to-transparent mb-8" />

              {/* Skills Section */}
              <div>
                <h3 className="text-2xl md:text-3xl bg-gradient-to-r from-gray-900 to-green-600 bg-clip-text text-transparent font-bold mb-6">
                  Technical Skills
                </h3>
                <Skills />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
